<template>
    <div @click="inPage__handleClick">
        <slot />
    </div>
</template>

<script>

export default {
    name: 'with-in-page-links',

    mixins: [],

    methods: {
        inPage__findAnchor(currentNode, parentNode) {
            do {
                if (currentNode.tagName == 'A') {
                    return currentNode
                }

                currentNode = currentNode.parentNode
            } while (currentNode && !currentNode.isSameNode(parentNode))

            return null
        },

        inPage__getType(href) {
            for (let url of this.inPage__urls) {
                if (href.indexOf(url) !== -1) {
                    return url
                }
            }

            return null
        },

        inPage__handleClick(event) {
            const { currentTarget, target } = event
            const $anchor = this.inPage__findAnchor(target, currentTarget)

            if ($anchor) {
                const { href } = $anchor
                const $targetID = $anchor.getAttribute('href')

                if ($targetID) {
                    const $targetElement = document.getElementById(
                        $targetID.substr(1)
                    )

                    if ($targetElement) {
                        event.preventDefault()

                        window.scrollBy({
                            top: Math.floor(
                                $targetElement.getBoundingClientRect().top - 42
                            ),
                            left: 0,
                            behavior: 'smooth',
                        })
                    }
                }
            }
        },
    },
}
</script>
